import React from 'react';
import { motion } from 'framer-motion';
export function Marquee() {
  const items = ['Presentations', 'Brochures', 'Website Design', 'Brand Identity', 'Business Cards', 'Presentations', 'Brochures', 'Website Design', 'Brand Identity', 'Business Cards'];
  return <div className="w-full overflow-hidden py-8 border-y border-ink/10 bg-cream-dark/30" data-id="element-133">
      <div className="relative flex whitespace-nowrap" data-id="element-134">
        <motion.div className="flex gap-12 px-6" animate={{
        x: [0, -1035]
      }} transition={{
        repeat: Infinity,
        ease: 'linear',
        duration: 20
      }} data-id="element-135">
          {items.map((item, index) => <div key={index} className="flex items-center gap-12" data-id="element-136">
              <span className="text-xl md:text-2xl font-serif italic text-ink-light" data-id="element-137">
                {item}
              </span>
              <span className="w-2 h-2 rounded-full bg-accent/50" data-id="element-138" />
            </div>)}
        </motion.div>
      </div>
    </div>;
}